import React from 'react';
import { renderFilterCell, convertToLocalDate } from 'smart-react';
import { formatDateTime } from '../../../../Utils/Common/commonUtils';
import {
  Tenants,
  testTypes,
  groupTypes,
  BooleanValues,
  BooleanFlagValues,
  fieldInfoTypes,
  mtfProtocol,
} from '../../Components/Lookup/LookupUtility';

/**
 * Returns a filter cell for the Status column.
 * @param {Object} props - Component props.
 * @returns {JSX.Element} JSX element representing the filter cell.
 */
export const TenantFilterCell = (props) => {
  var data = Tenants();
  return renderFilterCell(props, data, 'dropdown');
};

/**
 * Returns a filter cell for the test type column.
 * @param {Object} props - Component props.
 * @returns {JSX.Element} JSX element representing the filter cell.
 */
export const TestTypesFilterCell = (props) => {
  var data = testTypes();
  return renderFilterCell(props, data, 'dropdown');
};

/**
 * Returns a filter cell for the test group column.
 * @param {Object} props - Component props.
 * @returns {JSX.Element} JSX element representing the filter cell.
 */
export const TestGroupFilterCell = (props) => {
  var data = groupTypes();
  return renderFilterCell(props, data, 'dropdown');
};
/**
 * Handles Boolean Values filter cell.
 * @param {*} props
 * @returns JSX.Element
 */
export const BooleanValuesFilterCell = (props) => {
  var booleanValues = BooleanValues();
  return renderFilterCell(props, booleanValues, 'dropdown');
};
/**
 * Returns a grid date.
 * @param {*} props
 * @returns {JSX.Element} returns row cell
 */
export const GridDateCell = (props) => {
  let value = '';
  const { dataItem, field } = props;

  if (field?.includes('.')) {
    const fields = field?.split('.');
    value = dataItem[fields[0]][fields[1]];
  } else {
    value = dataItem[field];
  }
  return <td>{convertToLocalDate(value)}</td>;
};
/**
 * Returns a grid date time.
 * @param {*} props
 * @returns {JSX.Element} returns row cell
 */
export const GridDateTimeCell = (props) => {
  let value = '';
  const { dataItem, field } = props;

  if (field?.includes('.')) {
    const fields = field?.split('.');
    value = dataItem[fields[0]][fields[1]];
  } else {
    value = dataItem[field];
  }
  return <td>{formatDateTime(value)}</td>;
};
/**
 * Handles Boolean Values filter cell for true false.
 * @param {*} props
 * @returns JSX.Element
 */
export const BooleanFlagFilterCell = (props) => {
  var booleanValues = BooleanFlagValues();
  return renderFilterCell(props, booleanValues, 'dropdown');
};

/**
 * Returns a filter cell for the RF field info type column.
 * @param {Object} props - Component props.
 * @returns {JSX.Element} JSX element representing the filter cell.
 */
export const FieldInfoTypesFilterCell = (props) => {
  var data = fieldInfoTypes();
  return renderFilterCell(props, data, 'dropdown');
};
/**
 * Returns a filter cell for the RF MTF Protocol type column.
 * @param {Object} props - Component props.
 * @returns {JSX.Element} JSX element representing the filter cell.
 */
export const MTFProtocolFilterCell = (props) => {
  var data = mtfProtocol();
  return renderFilterCell(props, data, 'dropdown');
};
